import { Stack, Typography } from "@mui/joy";
import { ProgramContentType } from "data/BlockComponent";
import TextareaCell from "components/task/content/cell/TextareaCell";
import { theme } from "styles/theme";

export default function PresetCellV2({
  placeholder,
  initialHtmlString,
  initialValue,
  isCoach,
  setData,
  blockIndex,
  lineIndex,
  cellIndex,
  editorKey,
  id,
}: {
  placeholder?: string;
  initialHtmlString?: string | null;
  initialValue?: string | null;
  isCoach?: boolean;
  setData: React.Dispatch<
    React.SetStateAction<ProgramContentType[] | undefined>
  >;
  blockIndex: number;
  lineIndex: number;
  cellIndex: number;
  editorKey?: string;
  id?: string;
}) {
  const normalizedValue =
    typeof initialValue === "string" ? initialValue.trim() : "";
  const normalizedPlaceholder =
    typeof placeholder === "string" ? placeholder.trim() : "";
  const displayedText = normalizedValue || "";

  if (!isCoach) {
    return (
      <Typography
        variant={"Body"}
        sx={{
          width: "100%",
          color: theme.vars.palette.Content.Strong,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontWeight: 500,
        }}
      >
        {displayedText}
      </Typography>
    );
  }

  return (
    <Stack spacing={0.5} alignItems="end">
      <TextareaCell
        placeholder={placeholder}
        initialHtmlString={initialHtmlString}
        initialValue={initialValue}
        isCoachField
        isCoach={isCoach}
        setData={setData}
        lineIndex={lineIndex}
        cellIndex={cellIndex}
        blockIndex={blockIndex}
        editorKey={editorKey}
        id={id}
      />
    </Stack>
  );
}
